import React from 'react';
import WebDevHero from './components/WebDevHero';
import WebServices from './components/WebServices';
import WebProcess from './components/WebProcess';
import WebTechStack from './components/WebTechStack';
// import WebCaseStudies from './components/WebCaseStudies';
import WhyChooseUs from '../SoftwareDevelopment/components/WhyChooseUs';
import ContactFormWidget from '../../../components/ContactFormWidget';
import Footer from '../../../components/Footer';


const WebDev = () => {
  return (
    <div className="web-dev-page">
      <WebDevHero />
      <WebServices />
      <WebProcess />
      <WebTechStack />
      <WhyChooseUs />
      <ContactFormWidget />
      <Footer />
    </div>
  );
};

export default WebDev; 